{
    "titleaccount": "Bank Account Information",
    "titleaddress": "Bank Address",
    "input":{
        "accountnumber": "Account Number",
        "routingnumber": "Routing Number",
        "clabe": "CLABE",
        "iban": "IBAN",
        "swiftbic": "Swift BIC",
        "type": "Account Type",
        "additionalinformation": "Additional Information",
        "institutionname": "Institution Name",
        "institutionaddressline1": "Address Line 1",
        "institutionaddressline2": "Address Line 2",
        "institutionaddressline3": "Address Line 3",
        "institutioncity": "City",
        "institutionstate": "State",
        "institutioncountry": "Country",
        "institutionpostalcode": "Postal Code",
        "institutionunitnumber": "Unit Number"
    },
    "crypto": {
        "input": {
            "wallettype": "Wallet Type",
            "network": "Network",
            "walletaddress": "Wallet Address",
            "asset": "Asset"
        },
        "hasnotaccountwithasset": "You don't have an account with this asset. Please add an account to finish the operation."
    }
}